import _ from 'lodash';
import {
  clearIndicatorOverlayIntervals,
  clearLoadedTimes,
  extractIndicatorOverlayIntervals,
  resetLoadingIndex,
  setIndicatorOverlayIntervals,
  switchIndicators
} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {utcToLocalTime} from '../utils/time_utils';

export const extractOverlayIntervals = store => next => action => {

  const preState = store.getState();
  const dispatch = store.dispatch;

  switch (action.type) {
    case ActionTypes.EXTRACT_INDICATOR_OVERLAY_INTERVALS:
      const indicator = preState.indicators.active;
      if (indicator) {
        const time = preState.time;
        const intervals = _.flatMap(time.valid_times,
          value => {
            let available_time_index = indicator.available_times.contained_points[value];
            if (available_time_index !== undefined) {
              let interval = indicator.available_times.intervals[available_time_index];
              if (value === interval.contained_periods[0]) {
                return [interval];
              }
            }
            return [];
          })
                           .sort((i1, i2) => {
                             const wms_time = utcToLocalTime(time.selected_time);
                             const dateTime1 = utcToLocalTime(i1.starting_at);
                             const endDateTime1 = utcToLocalTime(i1.ending_at);
                             const dateTime2 = utcToLocalTime(i2.starting_at);
                             const endDateTime2 = utcToLocalTime(i2.ending_at);
                             if (dateTime1 === dateTime2) {
                               return 0;
                             } else if (wms_time > dateTime1 && wms_time <= endDateTime1) {
                               return -1;
                             } else if (wms_time > dateTime2 && wms_time <= endDateTime2) {
                               return 1;
                             } else if ((wms_time > dateTime1 && wms_time > endDateTime1 && wms_time > dateTime2) ||
                                        (wms_time < dateTime1 && wms_time < dateTime2)) {
                               if (dateTime1 < dateTime2) {
                                 return -1;
                               } else {
                                 return 1;
                               }
                             } else if (dateTime1 === wms_time) {
                               return -1;
                             } else if (dateTime2 === wms_time) {
                               return 1;
                             } else if (dateTime1 > wms_time) {
                               return -1;
                             } else {
                               return 1;
                             }
                           });
        dispatch(setIndicatorOverlayIntervals(intervals));
      }
      break;

    case ActionTypes.UPDATE_INDICATOR_TIMES:
    case ActionTypes.RESET_INDICATOR_OVERLAYS:
      dispatch(clearLoadedTimes());
      dispatch(resetLoadingIndex());
      dispatch(clearIndicatorOverlayIntervals());
      dispatch(extractIndicatorOverlayIntervals());
      break;

    default:
      break;
  }

  // Complete the current action ////////////////////////////////////////////////////////////////////////////
  const result = next(action);

  const postState = store.getState();

  switch (action.type) {
    case ActionTypes.SET_APP_MODE:
      const { app_mode } = postState.view;
      if (postState.indicators.active &&
          postState.indicators.active.only_in_app_mode &&
          postState.indicators.active.only_in_app_mode !== app_mode) {
        // If the layer does not exist in this app mode, toggle it off.
        dispatch(switchIndicators(postState.indicators.active.prefix));
      }
      break;
    default:
      break;
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/indicatorOverlaysMiddleware.js